import { createContext, useContext, useEffect, useState } from "react";
import { trackEvent } from "@/lib/api";

const CartContext = createContext(null);
const STORAGE_KEY = "teak_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (item) => {
    setItems((prev) => {
      const key = item.product_id + JSON.stringify(item.customization || {});
      const existing = prev.find((p) => (p.product_id + JSON.stringify(p.customization || {})) === key);
      if (existing) {
        return prev.map((p) => p === existing ? { ...p, quantity: p.quantity + item.quantity } : p);
      }
      return [...prev, item];
    });
    trackEvent("add_to_cart", { product_id: item.product_id });
  };

  const remove = (idx) => setItems((prev) => prev.filter((_, i) => i !== idx));
  const setQty = (idx, q) => setItems((prev) => prev.map((p, i) => i === idx ? { ...p, quantity: Math.max(1, q) } : p));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + (i.unit_price * i.quantity), 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
